// LastSync.tsx
import { FunctionComponent, useEffect, useState } from 'react';
import './LastSync.css';

import { useAuth } from '../../utility/useAuth';
import { getOption } from '../../services/ApiService';
import { formatDate, formatNumber,formatDateTime } from "../../config/formatters";
import { defaultFormatConfig, assignedFormatConfig,loadFormatConfig } from "../../config/formatConfig";

const LastSync: FunctionComponent = () => {
  const auth = useAuth();
  const [lastSyncTime, setLastSyncTime] = useState<string>('');

    useEffect(() => {
      if (!auth) return;
    
      loadFormatConfig(auth, getOption).catch(() => {
        // safe to ignore – loader falls back internally
      });
    }, [auth]);

  useEffect(() => {
    getOption(auth, 'LastSyncTime')
      .then((value) => {
        if (typeof value === 'string') {
          setLastSyncTime(value);
        }
      })
      .catch(() => {
        setLastSyncTime('Last sync unknown');
      });
  }, [auth]);

  return (
    <div className="lastsync-global-search-row">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          minWidth: 0,              // ✅ CRITICAL: prevents clipping
          paddingRight: 16          // ✅ right-side breathing room
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            minWidth: 0              // ✅ CRITICAL
          }}
        >
          <div
            style={{
              color: '#36424A',
              fontSize: 12,
              fontFamily: 'Noto Sans',
              fontWeight: 300,
              lineHeight: '18px',
              whiteSpace: 'nowrap'
            }}
          >
            Last data sync
          </div>

          <div
            style={{
              color: '#004D9E',
              fontSize: 12,
              fontFamily: 'Noto Sans',
              fontWeight: 400,
              lineHeight: '18px',
              whiteSpace: 'nowrap'
            }}
          >
            {formatDateTime(lastSyncTime, assignedFormatConfig) || '—'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastSync;